// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentPhoneNumberModel {
    static getAttributeTypeMap() {
        return EnrollmentPhoneNumberModel.attributeTypeMap;
    }
}
EnrollmentPhoneNumberModel.discriminator = undefined;
EnrollmentPhoneNumberModel.additionalProperties = false;
EnrollmentPhoneNumberModel.attributeTypeMap = [
    {
        "name": "phoneNumberId",
        "baseName": "phoneNumberId",
        "type": "number"
    },
    {
        "name": "countryCode",
        "baseName": "countryCode",
        "type": "string"
    },
    {
        "name": "areaCode",
        "baseName": "areaCode",
        "type": "string"
    },
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "primaryPhoneNumber",
        "baseName": "primaryPhoneNumber",
        "type": "boolean"
    },
    {
        "name": "phoneType",
        "baseName": "phoneType",
        "type": "ContactInfoType"
    },
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentPhoneNumberModel.js.map